import React, { useState, useEffect } from "react";
import Table from "../../Common/Table";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Permission from "../../Common/Permission";
import * as CampaignActions from "../../../store/actions/CampaignCities";
import TableFields from "../../../constants/CampaignCities/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { Pill } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import Campaign from "../../../store/reducers/Campaign";

export const CampaignCitiesList = (props) => {
  const { handleClose = () => {}, activeItem = {} } = props;
  useEffect(() => {
    props.getCampaignCities(activeItem.id);
  }, []);
  const getFieldValue = (campaign, key) => {
    switch (key) {
      case "active":
        if (campaign["active"] === false) {
          return <Pill isFalse>Inactive</Pill>;
        }
        return <Pill isFalse={false}>Active</Pill>;
      default:
        return getPath(campaign, key, "NA");
    }
  };
  return (
    <NoFooterModal
      heading={`Cities for ${activeItem.name} (ID: ${activeItem.id})`}
      header
      handleClose={handleClose}
    >
      <Table
        list={props.campaignCities}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </NoFooterModal>
  );
};
function mapStateToProps(state) {
  const { CampaignCities = {} } = state;
  return {
    campaignCities: CampaignCities.campaignCities,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCampaignCities: bindActionCreators(
      CampaignActions.getCampaignCitiesList,
      dispatch
    ),
    resetState: bindActionCreators(CampaignActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCitiesList);
